module.exports = __webpack_public_path__ + "static/O-SHYooLopez1-03ea7ecc4a7205356d4adddb768a6388.jpg";